import React, { Component, Fragment } from 'react';
import { Form, Select, Input, Button, Modal, Row, Col, Spin, Icon, Switch } from 'antd';
import CatalogoRequest from '../../services/Catalogo';
import UsuariosRequest from '../../services/Usuarios';
import { openNotification } from '../../util/notificaciones';
import { sanitizerTexto } from '../../util/utilerias';
import { esBarras, getSegmento } from '../../util/generics';
import { roles } from '../../util/Roles';
const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver formulario de usuario
 */
class FormUsuarios extends Component {
    state = {
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        plazasFiltradas: [],
        regionesUsuario: [],
        sucursalesUsuario: [],
        cargando: true,
        bloquearBotones: true,
        region_selected: undefined,
        esBarra: esBarras()
    }

    /**
     * Comportamiento del componente al recibir nuevos datos
     */
    componentDidMount = () => {
        let state = { ...this.state };
        CatalogoRequest.CargarRegiones()
            .then(response => {
                state.arrRegiones = response.data;
                return CatalogoRequest.CargarPlazas()
            })
            .then(response => {
                state.arrPlazas = response.data
                state.cargando = false;
                state.bloquearBotones = false;
                this.setState(state)
            })
            .catch(err => {
                this.setState({ bloquearBotones: false, cargando: false })
                openNotification(
                    "Ha ocurrido un error al cargar las regiones",
                    "Error"
                )
            })
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.usuario_selected !== prevProps.usuario_selected)) {
            if (this.props.usuario_selected !== null) {
                if (this.props.modo !== 'configurar') {

                    UsuariosRequest.CatalogosUsuario(this.props.usuario_selected.id)
                        .then(async response => {
                            const regiones = response.data.Regiones;
                            const sucursales = response.data.Sucursales;

                            let plazasFiltradas = state.arrPlazas.filter(item => sucursales.includes(item.sucursal));
                            let plazasEnviar = plazasFiltradas.map(item => item.id).toString();

                            state.region_selected = this.props.usuario_selected?.region?.id;
                            state.sucursal_selected = this.props.usuario_selected?.sucursal?.id;
                            state.regionesUsuario = regiones;
                            state.sucursalesUsuario = sucursales;
                            state.cargando = true;
                            state.arrSitios = [];

                            const sitiosResponse = await CatalogoRequest.CargarSitiosPlaza(plazasEnviar);
                            state.arrSitios = sitiosResponse.data;

                            if (!state.arrSucursales.length) {
                                const sucursalesDisponibles = await Promise.all(
                                    regiones.map(region => CatalogoRequest.CargarSucursalesRegion(region))
                                );

                                // Combinar todas las respuestas en un solo array
                                state.arrSucursales = sucursalesDisponibles.flatMap(resp => resp.data);
                            }

                            state.cargando = false;
                            this.setState(state);
                        })
                        .catch(err => {
                            openNotification("Ha ocurrido un error al listar la información del usuario.", "Error");
                        });

                    /* Método anterior */
                    // let plazasFiltradas = state.arrPlazas.filter(item => item.sucursal === this.props.usuario_selected?.sucursal?.id)
                    // let plazasEnviar = plazasFiltradas.map(item => item.id).toString();
                    // state.region_selected = this.props.usuario_selected?.region?.id
                    // state.sucursal_selected = this.props.usuario_selected?.sucursal?.id
                    // state.cargando = true;
                    // state.arrSitios = []
                    // this.setState(state, () => {
                    //     CatalogoRequest.CargarSitiosPlaza(plazasEnviar)
                    //         .then(response => {
                    //             state.arrSitios = response.data
                    //             console.log(response)
                    //             state.cargando = false;
                    //             this.setState(state)
                    //         })
                    //         .catch(err => {
                    //             openNotification(
                    //                 "Ha ocurrido un error al listar puntos de venta.",
                    //                 "Error"
                    //             )
                    //         })
                    // })

                    // if (!state.arrSucursales.length) {
                    //     console.log(1)
                    //     this.setState({ cargando: true }, () => {
                    //         CatalogoRequest.CargarSucursalesRegion(this.props.usuario_selected?.region?.id)
                    //             .then(response => {
                    //                 state.arrSucursales = response.data;
                    //                 console.log(response.data)
                    //                 this.setState(state)
                    //             })
                    //             .catch(err => {
                    //                 this.setState({ cargando: false })
                    //                 openNotification(
                    //                     "Ha ocurrido un error al listar las sucursales.",
                    //                     "Error"
                    //                 )
                    //             })
                    //     })
                    // }
                }
            }
        }
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }

        if (!state.esBarra || !Array.isArray(value)) {
            const { setFieldsValue } = this.props.form
            setFieldsValue({
                sucursal: undefined,
                sitio: []
            })
        }
        state.sucursal_selected = null;
        state.region_selected = value
        this.setState(state)
        if (value) {
            CatalogoRequest.CargarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error"
                )
            })
        }
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        if (!state.esBarra || !Array.isArray(value)) {
            const { setFieldsValue } = this.props.form
            setFieldsValue({
                sitio: []
            })
        }

        if (value) {
            state.sucursal_selected = value;
            state.cargando = true;
            this.setState(state)

            const sucursales = Array.isArray(value) ? value : [value]
            let plazasFiltradas = state.arrPlazas.filter(item => sucursales.includes(item.sucursal));
            plazasFiltradas = Array.isArray(plazasFiltradas) ? plazasFiltradas : [plazasFiltradas]
            let plazasEnviar = plazasFiltradas.map(item => item.id).toString();
            CatalogoRequest.CargarSitiosPlaza(plazasEnviar).then(response => {
                state.arrSitios = response.data
                state.cargando = false;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error"
                )
            })
        }
    }

    /**
    * Función que se manda a llamar cuando se cierra el modal
    * de formulario usuarios
    */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            region_selected: undefined,
            sucursal_selected: undefined
        })
    }

    /**
     * Función que se ejecuta cuando se confirma edición de usuario
     * @return: nada.
     */
    showConfirm = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar el usuario?</b> Se cambiará la información actual del usuario.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-usuarios-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-usuarios-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarUsuario)
                    },
                });
            }
        });
    }

    /**
     * Función que se ejecuta para editar el registro de usuario
     * @return: nada.
     */
    editarUsuario = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const mensaje = this.props.modo === 'configurar' ? 'configurado' : 'editado';
                if (this.props.modo === 'configurar') {
                    values.estatus = true
                    values.segmento = getSegmento()
                };

                if (this.state.esBarra && Array.isArray(values.region)) {
                    values.region = values.region[0]
                }
                if (this.state.esBarra && Array.isArray(values.sucursal)) {
                    values.sucursal = values.sucursal[0]
                }

                values.id = this.props.usuario_selected?.id
                this.setState({ cargando: true, bloquearBotones: true }, () => {
                    UsuariosRequest.ActualizarUsuario(values)
                        .then(response => {
                            this.setState({
                                cargando: false,
                                bloquearBotones: false,
                                region_selected: undefined,
                                sucursal_selected: undefined,
                            })
                            this.props.esconderModal(true);
                            this.props.form.resetFields();
                            openNotification(
                                `Se ha ${mensaje} el usuario correctamente.`,
                                'Éxito'
                            )
                        })
                        .catch(err => {
                            this.setState({ cargando: false, bloquearBotones: false })
                            openNotification(
                                "Ha ocurrido un error al configurar el usuario.",
                                "Error"
                            )
                        })
                })
            }
        })
    }

    incluyeRol = (roles, rolesBuscados) => {
        if (roles) {
            return roles.some(rol => rolesBuscados.includes(rol.descripcion))
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const usuario = this.props.usuario_selected;
        const modo = this.props.modo;
        return (
            <Modal
                title={modo === 'configurar' ? 'Configurar usuario' : modo === 'ver' ? 'Ver detalle de usuario' : 'Editar usuario'}
                onCancel={this.handleCancel}
                visible={this.props.visible}
                onOk={this.showConfirm}
                width={"60%"}
                maskClosable={false}
                centered={true}
                footer={
                    [
                        <Button
                            id="boton-regresar-form-usuarios"
                            className="btnCancelar"
                            key="back"
                            onClick={this.handleCancel}>
                            Regresar
                        </Button>,
                        <Button
                            className={this.props.modo !== "ver" ? 'btnVerCrearGuardar' : 'display-none'}
                            key="submit"
                            id="boton-guardar-form-usuarios"
                            type="primary"
                            disabled={this.state.bloquearBotones}
                            onClick={() => {
                                modo === 'configurar' ? this.editarUsuario() : this.showConfirm()
                            }}
                        >
                            Guardar
                        </Button>,
                    ]
                }
            >
                <Spin
                    tip="Cargando..."
                    indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                    spinning={this.state.cargando}
                    style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                    <Form onSubmit={this.showConfirm}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Form.Item
                                    label={modo === 'ver' ? <b>Nombre</b> : 'Nombre'}
                                    colon={false}
                                >
                                    {getFieldDecorator('nombre', {
                                        rules: [
                                            { required: false },
                                        ],
                                        initialValue: (
                                            usuario?.nombre
                                        )
                                    })(
                                        <Input
                                            id="input-nombre-form-usuarios"
                                            type="text"
                                            className='disableBtn'
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={modo === 'ver' ? <b>Usuario</b> : 'Usuario'}
                                    colon={false}
                                >
                                    {getFieldDecorator('usuario', {
                                        rules: [
                                            { required: false },
                                        ],
                                        initialValue: (
                                            usuario?.usuario
                                        )
                                    })(
                                        <Input
                                            id="input-usuario-form-usuarios"
                                            type="text"
                                            className='disableBtn'
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={modo === 'ver' ? <b>Email</b> : 'Email'}
                                    colon={false}
                                >
                                    {getFieldDecorator('email', {
                                        rules: [
                                            { required: false },
                                        ],
                                        initialValue: (
                                            usuario?.email
                                        )
                                    })(
                                        <Input
                                            id="input-email-form-usuarios"
                                            type="text"
                                            className='disableBtn'
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <br />
                            <Col span={8}>
                                <Form.Item
                                    label={modo === 'ver' ? <b>Roles</b> : 'Roles'}
                                    colon={false}
                                >
                                    {getFieldDecorator('roles', {
                                        rules: [
                                            { required: false },
                                        ],
                                        initialValue: (
                                            usuario?.roles?.map(item => item.descripcion).join(', ')
                                        )
                                    })(
                                        <Input
                                            id="input-roles-form-usuarios"
                                            type="text"
                                            className='disableBtn'
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={modo !== "ver" ? "Región" : <b>Región</b>}
                                    colon={modo === 'ver' ? false : true}
                                >
                                    {getFieldDecorator('region', {
                                        rules: [
                                            {
                                                required: modo === 'ver' ? false : true,
                                                message: 'Por favor, seleccione una región.'
                                            },
                                        ],
                                        //Revisa si el select admite multiseleccion y le asigna el arreglo de regiones o asigna la región del usuario (cuando es drive)
                                        initialValue: (this.incluyeRol(usuario?.roles, [roles.Barista, roles.Asesor]) || !this.state.esBarra) ?
                                            (usuario?.region?.id ?? undefined) : (this.state.regionesUsuario ?? undefined)

                                    })(
                                        <Select
                                            id="select-region-form-usuarios"
                                            mode={(this.incluyeRol(usuario?.roles, [roles.Barista, roles.Asesor]) || !this.state.esBarra) ? 'default' : 'multiple'}
                                            showSearch
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeRegion}
                                            allowClear
                                            filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                            showArrow={modo === 'ver' ? false : true}
                                            disabled={modo === 'ver' ? true : false}
                                            className={modo === 'ver' ? 'disableInput' : ''}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrRegiones?.length > 0 &&
                                                this.state.arrRegiones.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre_corto}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={modo !== "ver" ? "Sucursal" : <b>Sucursal</b>}
                                    colon={modo === 'ver' ? false : true}
                                >
                                    {getFieldDecorator('sucursal', {
                                        rules: [
                                            {
                                                required: modo === 'ver' ? false : true,
                                                message: 'Por favor, seleccione una sucursal.'
                                            },
                                        ],
                                        initialValue: (this.incluyeRol(usuario?.roles, [roles.Barista]) || !this.state.esBarra) ?
                                            (usuario?.sucursal?.id ?? undefined) : (this.state.sucursalesUsuario ?? undefined)
                                    })(
                                        <Select
                                            id="select-sucursal-form-usuarios"
                                            mode={(this.incluyeRol(usuario?.roles, [roles.Barista]) || !this.state.esBarra) ? 'default' : 'multiple'}
                                            showSearch
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeSucursal}
                                            allowClear
                                            filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                            showArrow={modo === 'ver' ? false : true}
                                            disabled={(modo !== 'ver' && this.state.region_selected) ? false : true}
                                            className={(modo !== 'ver' && this.state.region_selected) ? '' : 'disableInput'}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrSucursales?.length > 0 &&
                                                this.state.arrSucursales.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            {/* (modo === 'configurar' || !usuario?.segmento) && <Col span={8}>
                                <Form.Item
                                    label={modo !== "ver" ? "Segmento" : <b>Segmento</b>}
                                    colon={modo === 'ver' ? false : true}
                                >
                                    {getFieldDecorator('segmento', {
                                        rules: [{ required: modo === 'ver' ? false : true, message: 'Por favor, seleccione un segmento.' }],
                                        initialValue: usuario?.segmento
                                    })(
                                        <Select
                                            defaultActiveFirstOption={false}
                                            style={{ width: "100%" }}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            disabled={(modo !== 'ver') ? false : true}
                                            className={(modo !== 'ver') ? '' : 'disableInput'}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            <Option key={'Drive'} value={1}>{'Drive'}</Option>
                                            <Option key={'Barras'} value={2}>{'Barras'}</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col> */}

                            <Col span={16}>
                                <Form.Item
                                    label={modo !== "ver" ? "Puntos de venta" : <b>Puntos de venta</b>}
                                    colon={modo === 'ver' ? false : true}
                                >
                                    {getFieldDecorator('sitio', {
                                        rules: [{ required: modo === 'ver' ? false : true, message: 'Por favor, seleccione al menos un punto de venta.' }],
                                        initialValue: usuario?.sitio
                                    })(
                                        <Select
                                            allowClear={true}
                                            mode={(this.incluyeRol(usuario?.roles, [roles.Barista])) ? 'default' : 'multiple'}
                                            showSearch
                                            defaultActiveFirstOption={false}
                                            style={{ width: "100%" }}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            disabled={(modo !== 'ver' && this.state.sucursal_selected) ? false : true}
                                            className={(modo !== 'ver' && this.state.sucursal_selected) ? '' : 'disableInput'}
                                            onChange={this.handleChangeSitio}
                                            filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        >
                                            {/* Opciones de puntos de venta */}
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrSitios?.length > 0 &&
                                                this.state.arrSitios.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className={modo === 'configurar' ? 'display-none' : ''} span={8}>
                                <Form.Item
                                    label={modo !== "ver" ? "Estatus" : <b>Estatus</b>}
                                    colon={modo === 'editar' ? true : false}
                                >
                                    {getFieldDecorator('estatus', {
                                        rules: [
                                            {
                                                required: modo === 'editar' ? true : false,
                                                message: 'Por favor, seleccione un estatus.'
                                            },
                                        ],
                                        initialValue: (
                                            usuario?.activo ?? true
                                        ),
                                        valuePropName: 'checked'
                                    })(
                                        <Switch
                                            className={this.props.form.getFieldValue("activo") ? "colorSwitchActivo" : "colorSwitchInactivo"}
                                            disabled={this.props.modo === "ver"}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        )
    }
}

export default Form.create()(FormUsuarios);